import { useEffect, useRef } from "react";
import useStorageState from "../useStorageState";

export default function useFlowData(
  locationClient,
  updateInterval = 10000,
  isFocused = true,
  storage = null,
) {
  const [flowData, saveFlowData, setFlowData] = useStorageState(
    storage,
    "flowData",
    null,
  );

  const initialized = useRef(false);
  const interval = useRef(null);

  const updateFlow = async () => {
    try {
      const response = await locationClient.getFlow();
      saveFlowData(response.data);
      return true;
    } catch (error) {
      console.warn('Error in "updateFlow"', error, error.stack);
      return false;
    }
  };

  const initData = async () => {
    await loadData();
    initialized.current = true;
  };

  const loadData = updateFlow;

  const clearData = () => {
    setFlowData(null);
    initialized.current = false;
  };

  useEffect(() => {
    if (isFocused) initData();
    else clearData();
  }, [isFocused]);

  const startRecurrentUpdate = (intervalTime) => {
    if (!interval.current)
      interval.current = setInterval(() => loadData(), intervalTime);
  };

  const stopRecurrentUpdate = () => {
    if (interval.current) {
      clearInterval(interval.current);
      interval.current = null;
    }
  };

  useEffect(() => {
    if (initialized.current && updateInterval) {
      startRecurrentUpdate(updateInterval);
      return stopRecurrentUpdate; // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
    }
    if (!initialized.current) stopRecurrentUpdate();
  }, [initialized.current]);

  return {
    flowData,
    data: { update: loadData, clear: clearData, init: initData },
    recurrentUpdate: { start: startRecurrentUpdate, stop: stopRecurrentUpdate },
  };
}
